import React, { memo } from "react";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Scholarship } from "@/lib/api/scholarship";
import { format } from "date-fns";
import { EmptyPlaceholderField } from "./partials/EmptyPlaceholderField";

export const ScholarshipDetail = memo(({ data, setDegreeInformation }: { data: Scholarship | null; setDegreeInformation: React.Dispatch<React.SetStateAction<Scholarship | null>> }) => {
	if (data === null) {
		return <></>;
	}
	return (
		<div>
			<Dialog
				open={data !== null}
				onOpenChange={() => {
					setDegreeInformation(null);
				}}
			>
				<DialogContent className='max-w-6xl'>
					<DialogHeader>
						<DialogTitle>Thông Tin Chi Tiết Khen thưởng - Chứng nhận</DialogTitle>
					</DialogHeader>
					<div className='grid grid-cols-1 gap-3 h-[50dvh] overflow-y-scroll pb-4 px-1'>
						<div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3'>
							<div className='col-span-1 text-red-600 font-bold'>Thông tin cá nhân</div>
							<div>
								<Label className='mb-1'>Mã sinh viên</Label>
								<EmptyPlaceholderField data={data.studentId} />
							</div>
							<div>
								<Label className='mb-1'>Họ và tên</Label>
								<div style={{'textTransform': 'capitalize'}}>
									<EmptyPlaceholderField data={data.studentName} />
								</div>
							</div>
							<div>
								<Label className='mb-1'>Ngày sinh</Label>
								<EmptyPlaceholderField data={data.dateOfBirth ? format(data.dateOfBirth, 'dd/MM/yyyy') : ""} />
							</div>
							<div>
								<Label className='mb-1'>CCCD</Label>
								<EmptyPlaceholderField data={data.cccd} />
							</div>

							<div className='col-span-1 text-red-600 font-bold'>Thông tin Khen thưởng - Chứng nhận</div>
							<div>
								<Label className='mb-1'>Năm học</Label>
								<EmptyPlaceholderField data={data.year} />
							</div>
							<div>
								<Label className='mb-1'>Học kỳ</Label>
								<EmptyPlaceholderField data={data.semester} />
							</div>
							<div>
								<Label className='mb-1'>Ngành</Label>
								<EmptyPlaceholderField data={data.major} />
							</div>
							{/* <div>
								<Label className='mb-1'>Điểm trung bình</Label>
								<EmptyPlaceholderField data={data.gpa} />
							</div> */}
							{/* <div>
								<Label className='mb-1'>Điểm rèn luyện</Label>
								<EmptyPlaceholderField data={data.conductScore} />
							</div> */}
							<div>
								<Label className='mb-1'>Mã KT-CN</Label>
								<EmptyPlaceholderField data={data.scholarshipCode} />
							</div>
							<div>
								<Label className='mb-1'>Tên KT-CN</Label>
								<EmptyPlaceholderField data={data.scholarshipName} />
							</div>
							<div>
								<Label className='mb-1'>Danh hiệu</Label>
								<EmptyPlaceholderField data={data.title} />
							</div>
							{/* <div>
								<Label className='mb-1'>Số tiền Khen thưởng - Chứng nhận</Label>
								<EmptyPlaceholderField data={data.amount} />
							</div> */}
							<div>
								<Label className='mb-1'>Số quyết định</Label>
								<EmptyPlaceholderField data={data.certificateNo} />
							</div>
							{/* <div>
								<Label className='mb-1'>Mức phần trăm</Label>
								<EmptyPlaceholderField data={data.percentLevel} />
							</div> */}
							<div className='md:col-span-1 lg:col-span-1'>
								<Label className='mb-1'>Ghi chú</Label>
								<EmptyPlaceholderField data={data.notes} />
							</div>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
});
